export enum WizardStep {
  Welcome = 1,
  UserNotes = 2,
  UploadMap = 3,
  ResourceConfig = 4,
  AiModeSelection = 5,
  ManualConfirm = '5a',
  AiModeConfirm = '5b',
  GuidedConfirm = '5c',
  GuidedConfirm2 = '5d',
  WorldIdentity = 6,
  GlobalContext = 7,
  GlobalContext2 = '7b',
  GlobalContext3 = '7c',
  GlobalContext4 = '7d',
  Cultures = 8,
  Religions = 9,
  States = 10,
  Provinces = 11,
  ReviewCreate = 12
}
